<template lang="pug">
    footer.footer.px-32.pt-40.pb-40.bg-grey-e6.w-full.h-160
      .flex.justify-between.flex-wrap.max-w-1366.m-auto
        .right.flex.items-center

        .flex.divide-x.divide-black.align-middle.items-center
          span.cursor-pointer(v-for="(item,index) in link" ) 
            a.px-24(:href="item.link" v-if="item.link" target="_blank") {{item.name}}
            .px-24(:href="item.id" v-else @click="footerLink(item)") {{item.name}}

      .text-12.mt-48.text-right.max-w-1366.m-auto {{$t('__headerFooter.__copyright')}} © {{ currentYear }} {{$t('__headerFooter.__asusTekComputerIncAllRightsReserved')}}
      Modal.h-auto.font-custom(
        :show="show" 
        :clickOutSideClose="true" 
        @closeModal="modalClose" 
        :body="'footerBody'" 
        footer="footer"  
        :type="modalRelate.type"
        padding="0 20px"
        maxWidth="828px"
        )
        template(#footerBody)
          .h-438.max-w-788.pt-36
            .flex.items-center
              .w-96.min-w-96.flex-shrink-0(:style="{'width': '280px' }" )
                img.w-full(:src="getImgUrl(modalRelate.modalContent.pic)")
              .p-10.pl-32.pr-20.text-left
                .text-main-0.text-18.mb-32.font-600  {{modalRelate.modalContent.title}}
                .overflow-y-auto.overflow-x-hidden.h-240.pr-2
                  //
                  span.leading-24(v-html="$xss(modalRelate.modalContent.content)") 
            //- ModalAlert(:data="modalRelate.modalContent" :picWidth="'280'" :align="true")
          
        //- template(#footer)
        //-   Button.mt-10(:text="$t('__globeButton.__close')" type="normal" :disable="false" @buttonClick='modalClose')
</template>

<script>
import Select from '@/components/Select.vue'
import Modal from '@/components/Modal.vue';
import ModalAlert from '@/components/ModalAlert.vue';
import Button from '@/components/Button.vue';
import "@/assets/scss/vSelect/VSelect.scss";

import { EMAIL} from '@/enum/global';




export default {
  name: 'Footer',
  components:{
    Select,
    Modal,
    ModalAlert,
    Button
  },
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    hasBgColor: {
      type: Boolean,
      default: true,
    }
  },
  data(){
    return {
      show: false,
      contactEmailList : ''
    }
  },
  created(){
  },
  mounted(){
    
  },
  methods:{
    getImgUrl(pet) {
      let images = require.context('../assets/', false, /\.png$/)
      return images('./' + pet + ".png")
    },
    modalClose() {
      this.show = false;

    },
    changeEmail(){
      let emailVal = this.$store.state.user.user.service_engineer

      if(emailVal.length > 0){
        this.contactEmailList = '';
        emailVal.forEach((item, index) => {
            let dot = (index === item.length - 1) ? '' : ';';
            this.contactEmailList += item + dot;
        })
        console.log('contactEmailList', this.contactEmailList);
        this.$forceUpdate();
      } 
      for (let i = 0; i < this.link.length; i++) {
        if(this.link[i].id == 'contactUs'){
          this.link[i].link = 'mailto:' + this.contactEmailList  
        }
      }
    },
    footerLink(item){
      if(item.data){
        this.modalRelate.modalContent  = item.data
        this.show = true;
      }else{
        if(item.id === 'f'){
          this.$router.push({path: '/faq'}).catch(err => err);
        }
      }
    },

  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
    link(){
      let arr = [
        {
          name: 'ASUS商業採購網',
          link: 'https://smb.asus.com/',
          id: 'a',
        },
        {
          name: this.$t('__headerFooter.__disclaimer'),
          id: 'b',
          data:{
            title: this.$t('__popUpRelated.__betaDisclaimer'),
            content:`<div class="font-s500 text-18 mb-6">${this.$t('__headerFooter.__disclaimer')}</div> 
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaDisclaimerText1')}</div> 
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaDisclaimerText2')}</div> 
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaDisclaimerText3')}</div> 
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaDisclaimerText4')}</div> `,
            pic: 'im-image-disclamimer',
          }
        },
        
        {
          name: this.$t('__headerFooter.__privacyNotice'),
          id: 'd',
          data:{
            title: this.$t('__popUpRelated.__betaPrivacyNotice'),
            content:`<div class="font-s500 text-18 mb-6">${this.$t('__headerFooter.__privacyNotice')}</div> 
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaPrivacyNoticeText')} 
            <a class="text-main-0 hover:text-main-deep hover:underline" href="https://www.asus.com/Terms_of_Use_Notice_Privacy_Policy/Privacy_Policy">${this.$t('__popUpRelated.__betaPrivacyNoticeLink')}</a>
            </div> 
            `,
            pic: 'im-image-disclamimer',
          }
        },
        {
          name: this.$t('__headerFooter.__termsOfUseNotice'),
          id: 'c',
          data:{
            title: this.$t('__popUpRelated.__betaTermsOfUseNotice'),
            content:`<div class="font-s500 text-18 mb-6">${this.$t('__headerFooter.__termsOfUseNotice')}</div> 
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText1')}</div>
            <div class="text-16 font-s500">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText2')}</div>
            <div class="text-16">1.1</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText3')}</div>
            <div class="text-16">1.2</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText4')}</div>
            <div class="text-16">1.3</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText5')}</div>
            <div class="text-16">1.4</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText6')}</div>
            <div class="text-16">1.5</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText7')}</div>
            <div class="text-16">1.6</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText8')}</div>
            <div class="text-16">1.7</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText9')}</div>
            <div class="text-16">1.8</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText10')}</div>
            <div class="text-16">1.8.1</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText11')}</div>
            <div class="text-16">1.8.2</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText12')}</div>
            <div class="text-16">1.8.3</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText13')}</div>
            <div class="text-16">1.8.4</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText14')}</div>

            <div class="text-16 font-s500">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText15')}</div>
            <div class="text-16">2.1</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText16')}</div>
            <div class="text-16">2.2</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText17')}</div>
            <div class="text-16">2.3</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText18')}</div>
            <div class="text-16">2.4</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText19')}</div>
            <div class="text-16">2.5</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText20')}</div>
            <div class="text-16">2.6</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText21')}</div>
            <div class="text-16">2.7</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText22')}</div>
            
            <div class="text-16 font-s500">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText23')}</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText24')}</div>
            <div class="text-16">3.1</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText25')}</div>
            <div class="text-16">3.2</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText26')}</div>
            <div class="text-16">3.3</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText27')}</div>
            <div class="text-16">3.4</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText28')}</div>
            
            <div class="text-16 font-s500">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText29')}</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText30')}
            <a class="text-main-0 hover:text-main-deep hover:underline" href="https://www.asus.com/Terms_of_Use_Notice_Privacy_Policy/Privacy_Policy">${this.$t('__popUpRelated.__betaPrivacyNoticeLink')}</a>
            </div>
            
            <div class="text-16 font-s500">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText31')}</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText32')}</div>
            <div class="text-16">5.1</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText33')}</div>
            <div class="text-16 font-s500">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText34')}</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText35')}</div>
            
            <div class="text-16 font-s500">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText36')}</div>
            <div class="text-16">7.1</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText37')}</div>
            <div class="text-16">7.1</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText38')}</div>

            <div class="text-16 font-s500">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText39')}</div>
            <div class="text-16">8.1</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText40')}</div>
            <div class="text-16">8.2</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText41')}</div>
            <div class="text-16">8.3</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText42')}</div>
            <div class="text-16">8.4</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText43')}</div>
            <div class="text-16">8.5</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText44')}</div>
            <div class="text-16">8.5.1</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText45')}</div>
            <div class="text-16">8.5.2</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText46')}</div>
            <div class="text-16">8.5.3</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText47')}</div>
            <div class="text-16">8.5.4</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText48')}</div>
            <div class="text-16">8.5.5</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText49')}</div>
            <div class="text-16 font-s500">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText50')}</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText51')}</div>
            <div class="text-16 mb-16">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText52')}</div>

            <div class="text-16 ">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText53')}</div>
            <div class="text-16 ">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText54')}</div>
            <div class="text-16 ">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText55')}</div>
            <div class="text-16 ">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText56')}</div>
            <div class="text-16 ">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText57')}</div>
            <div class="text-16 ">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText58')}</div>
            <div class="text-16 ">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText59')}</div>
            <div class="text-16 ">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText60')}</div>
            <div class="text-16 ">${this.$t('__popUpRelated.__betaTermsOfUseNoticeText61')}</div>
            `,
            pic: 'im-image-disclamimer',
          }
        },
        {
          name: this.$t('__headerFooter.__contactUs'),
          id: 'contactUs',
          link:'mailto:#TW_Tech_Expert@asus.com',
        },
        {
          name: this.$t('__faqRelated.__faq'),
          id: 'f',
          
        },
        
      ]
      if(this.$store.state.user.user['country'] != 'TW'){
        if(arr[0].id == 'a'){
          arr.shift()
        }
      }

      return arr
    },
    modalRelate(){
      return {
        modalContent:{
          // title:this.$t('__popUpRelated.__submitRepackRequest'),
          // content:this.$t('__popUpRelated.__itWillTakeUpToSeveralDaysToCompleteTheRepack'),
          // pic: 'im-image-disclamimer',
        },
      }
    }
    
  },
  watch:{
    '$store.state.user.user': function() {
      this.changeEmail()
      // console.log('whattt',this.$store.state.user.user)
    }
    
  },
}
</script>

<style lang="scss" scoped>

.font-custom {
  box-sizing: border-box;
  font-family: 'TT Norms Pro Medium','TT Norms Pro Bold','Segoe-Mediu','Segoe-Bold';
  
}

</style>
